import { SubmitCelebrationCard } from "./cards/SubmitCelebrationCard";

export default function SubmitCelebrationPage() {
  return (
    <div className="flex min-h-[100dvh] items-center justify-center bg-background px-4 py-8">
      <div className="w-full max-w-3xl">
        <SubmitCelebrationCard data={{ firstName: "" }} />
      </div>
    </div>
  );
}
